import { render, staticRenderFns } from "./LocationContactCards.vue?vue&type=template&id=60f62948&"
import script from "./LocationContactCards.vue?vue&type=script&lang=js&"
export * from "./LocationContactCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports